import { useEffect, useState } from 'react'
import { lockLabel } from '@/lib/time'

/* ── THE SIGNATURE ────────────────────────────────────────────────────────────
   Entering a week plays a full-bleed navy title card that wipes up into the
   picks. The entire motion budget lives here; nothing else on the screen
   animates, which is what makes it land.

   Plays once per week per session — a card you have already watched is an
   obstacle, not an entrance. */
export default function TitleCard({
  title,
  locksAt,
  storageKey,
}: {
  title: string
  locksAt: string | null
  storageKey: string
}) {
  const [play, setPlay] = useState(() => !sessionStorage.getItem(`sa:card:${storageKey}`))

  useEffect(() => {
    if (!play) return
    sessionStorage.setItem(`sa:card:${storageKey}`, '1')
    const t = setTimeout(() => setPlay(false), 1400)
    return () => clearTimeout(t)
  }, [play, storageKey])

  if (!play) return null

  return (
    <div
      aria-hidden="true"
      className="title-card bg-navy fixed inset-0 z-40 flex flex-col items-center justify-center px-8"
    >
      <p
        className="title-card-line font-mono text-eyebrow tracking-[0.16em] text-white/60 uppercase mb-6"
        style={{ animationDelay: '90ms' }}
      >
        {locksAt ? `Picks close ${lockLabel(locksAt)}` : 'Schedule pending'}
      </p>
      <h1
        className="title-card-line font-display text-card text-center text-white"
        style={{ animationDelay: '180ms' }}
      >
        {title}
      </h1>
    </div>
  )
}
